// extracted by mini-css-extract-plugin
export default {"timeOffContainer":"PersonTimeOffRow-module__timeOffContainer___jv1bW","showBottomBorder":"PersonTimeOffRow-module__showBottomBorder___TCR_6"};